module.exports = __webpack_public_path__ + "static/media/sf_2800_gray.d13fa002cea92ab4e3dafd8dc3e3b1ae.png";